import ReactGA from 'react-ga4';
import { Result } from '@hitiq/generic';
import { Logger, LogType } from '@hitiq/logger';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { v4 as uuidv4 } from 'uuid';
import { ModelTypes } from '../../dataStorePersistence/DataStoreModel';
import { Persistance } from '../../dataStorePersistence/persistence';
import { Translator } from '../translator.interface';
import { CreateIncidentInput, IncidentBackend } from './incident.interface';

export const createIncidentThunk = createAsyncThunk(
  'incident/createIncident',
  async (
    payload: {
      translator: Translator<IncidentBackend, CreateIncidentInput>;
      persistence: Persistance<IncidentBackend>;
      loggingService: Logger;
      resource: CreateIncidentInput;
    },
    thunkAPI,
  ): Promise<any> => {
    const { loggingService, persistence, translator, resource } = payload;

    const incident: CreateIncidentInput = newIncident(resource);
    const backendResource = translator.translateOneToBackendModel(incident);

    const result: Result<IncidentBackend> = await persistence.create(
      backendResource,
    );
    loggingService.log(LogType.info, `Incident: ${result.data.id} created.`);

    if (result.error) {
      loggingService.log(
        LogType.error,
        `Incident: creation failed: ${result.error}`,
      );
      return onError(thunkAPI, result.error);
    }

    ReactGA.event({
      category: 'Incident',
      action: 'Create',
    });

    // WARNING: don't use response in redux since onCreate will do this.
    return true;
  },
);

function newIncident(resource: CreateIncidentInput): CreateIncidentInput {
  return {
    id: 'not empty',
    copyOfId: '_ORIGINAL_',
    modelType: ModelTypes.Incident,
    report: resource.report,
    accountId: resource.accountId,
    accountName: resource.accountName,
    createdByAccountId: resource.createdByAccountId,
    playerId: resource.playerId,
    incidentDateTime: new Date(resource.incidentDateTime).toISOString(),
    playerFullName: resource.playerFullName,
    createdByAccountName: resource.createdByAccountName,
    createdByUserId: resource.createdByUserId,
    createdByUserFullName: resource.createdByUserFullName,
    notes: resource.notes,
  };
}

function onError(thunkAPI: any, error: Error) {
  // TODO: remove case ? or keep it so we can reuse it in a retry.
  return thunkAPI.rejectWithValue({
    heading: 'Unable to create assessment',
    message: error.message,
    severity: 'error',
    id: uuidv4(),
  });
}
